(function (jimdoData, $) {
    "use strict";

    var validators =
    {
        "mail": /\S+@\S+\.\S+/,
        "text": /^\s*\S+.*/
    };

    var validate = function(element, re)
    {
        var $el = $('#' + element);
        var valid = !re.test($el.val());

        $el.toggleClass('error', valid);
        $el.prev().toggleClass('error', valid);
    };

    var hideOverlay = function()
    {
        $('#contact-form').removeClass('show');
        $('#contact-overlay').removeClass('show');
    };

    var showOverlay = function()
    {
        $('#contact-overlay').addClass('show');
        $('#contact-form').addClass('show');

        $('#contact-mail').val('');
        $('#contact-name').val('');
        $('#contact-text').val('');
    };

    $(document).ready(function() {
        $('.pp-contactform-item-thanks').hide();

        $('input, textarea').on('focus', function() {
            $(this).removeClass('error');
            $(this).prev().removeClass('error');
        });

        $('#contact-form-close').click(function(e) {
            e.preventDefault();
            hideOverlay();
        });

        $('#show-contact').click(function(e) {
            e.preventDefault();
            showOverlay();

            $('.pp-contactform-item-submit').show();
            $('.pp-contactform-item-thanks').hide();
        });

        $('#linkPrivacyPolicy').click(function(e) {
            e.preventDefault();

            $('#legalOverlayPrivacyPolicy').toggleClass('show');
        });

        $('#linkImprint').click(function(e) {
            e.preventDefault();

            $('#legalOverlayImprint').toggleClass('show');
        });

        $('.pp-legal-close-button').click(function(e) {
            e.preventDefault();

            $('.pp-legal-overlay').removeClass('show');
        });

        function toggleSendButton(active) {
            $('.pp-contactform-item-submit').find('button').prop('disabled', !active);
        }

        function showError() {
            toggleSendButton(true);
        }

        $('#contact').submit(function(e) {
            e.preventDefault();

            $('.pp-contactform-item-error').hide();

            validate('contact-mail', validators.mail);
            validate('contact-name', validators.text);
            validate('contact-text', validators.text);

            if ($('#contact .error').length === 0) {
                toggleSendButton(false);

                $.post($(this).attr('action'), $('#contact').serialize())
                    .then(function(response) {
                        toggleSendButton(true);
                        if (response.status === 'error') {
                            if (response.message === 'captchaInvalid') {
                                $('.pp-contactform-item-captcha-error').show();
                            } else {
                                showError();
                            }
                        } else {
                            $('.pp-contactform-item-submit').hide();
                            $('.pp-contactform-item-success').show();
                        }
                    }, showError);
            } else {
                toggleSendButton(true);
            }
        });
    });
})(require('jimdoData'), require('jquery'));



/*****************
 ** WEBPACK FOOTER
 ** ./webserver/document_root/s/js/web/modules/underconstruction/index.js
 ** module id = 3714
 ** module chunks = 250
 **/